<template>
  <div>
    <v-dialog v-model="dialog.company" 
      persistent
      scrollable
      width="700">
      <v-card class="border-radius box-shadow">
        <v-card-title class="body-2 text-first d-flex blue-grey lighten-5 py-5">
          Lengkapi Data Perusahaan
        </v-card-title>
        <v-card-text style="height: 100vh;" class="mt-5">
          <ValidationObserver ref="observer" style="width: 100%;">
            <v-form>
              <p class="body-2">
                Silahkan masukkan informasi data perusahaan anda, kemudian tekan tombol <b>Simpan</b>.
              </p>

              <p class="caption mb-2">
                <b>Logo Perusahaan</b>
              </p>
              <v-img 
                contain
                width="200"
                height="200"
                min-height="200"
                alt="property"
                style="border-radius: 20px;"
                gradient="to top right, rgba(0,0,0,.3), rgba(0,0,0,.3)"
                :src="form.logo_url === '' ? require('@/assets/image/no-image-available.jpg') : form.logo_url">
                <image-input v-model="images">
                  <div slot="activator">
                    <v-btn
                      rounded
                      block
                      color="#000"
                      class="text-capitalize white--text"
                      elevation="0"
                      style="position: absolute; bottom: 0px; width: 100%; opacity: 50%;">
                      <v-icon color="white" class="cursor-pointer mr-2">mdi-camera-outline</v-icon> Ubah Gambar
                    </v-btn>
                  </div>
                </image-input>
              </v-img>

              <p class="caption mt-6 mb-2">
                <span class="red--text">*</span>
                <b>Nama Perusahaan</b>
              </p>
              <ValidationProvider name="Nama Perusahaan" rules="required" v-slot="{ errors }">
                <v-text-field
                  style="width: 49%;"
                  dense
                  outlined
                  single-line
                  :color="style.primary"
                  placeholder="Nama Perusahaan"
                  prepend-inner-icon="mdi-account-circle-outline"
                  v-model="form.name"
                  :error-messages="errors"
                  require>
                </v-text-field>
              </ValidationProvider>

              <p class="caption mb-2">
                <span class="red--text">*</span>
                <b>Nama Pemilik Perusahaan</b>
              </p>
              <ValidationProvider name="Nama Pemilik" rules="required" v-slot="{ errors }">
                <v-text-field
                  style="width: 49%;"
                  dense
                  outlined
                  single-line
                  :color="style.primary"
                  placeholder="Nama Pemilik"
                  prepend-inner-icon="mdi-account-tie-outline"
                  v-model="form.contact_name"
                  :error-messages="errors"
                  require>
                </v-text-field>
              </ValidationProvider>

              <p class="caption mb-2">
                <b>Alamat Email Perusahaan</b>
              </p>
              <v-text-field
                style="width: 40%;"
                dense
                outlined
                single-line
                :color="style.primary"
                placeholder="Alamat Email"
                prepend-inner-icon="mdi-email-outline"
                v-model="form.contact_email">
              </v-text-field>
              
              <p class="caption mb-2">
                <b>Nomor Handphone Perusahaan</b>
              </p>
              <v-text-field
                style="width: 40%;"
                dense
                outlined
                single-line
                :color="style.primary"
                placeholder="Nomor Handphone"
                prepend-inner-icon="mdi-cellphone-iphone"
                type="number"
                :counter="13"
                v-model="form.contact_mobilephone">
              </v-text-field>

              <p class="caption mb-2">
                <b>Nomor Telepon Perusahaan</b>
              </p>
              <v-text-field
                style="width: 40%;"
                dense
                outlined
                single-line
                :color="style.primary"
                placeholder="Nomor Telepon"
                prepend-inner-icon="mdi-phone-classic"
                type="number"
                :counter="13"
                v-model="form.contact_phone">
              </v-text-field>

              <p class="caption cursor-pointer d-flex align-center" @click="edit.address = !edit.address ? true : false">
                <v-icon>{{ !edit.address ? 'mdi-chevron-down' : 'mdi-chevron-up' }}</v-icon>
                <span v-if="!edit.address">
                  Anda bisa menambahkan <b>alamat</b> disini
                </span>
                <span v-else>
                  <b>Alamat Perusahaan</b> (bisa dikosongi)
                </span>
              </p>
              
              <div v-if="edit.address">
                <p class="caption mb-2">
                  <b>Detail Alamat</b>
                </p>
                <div style="width: 60%;"
                  class="v-input v-input--dense theme--light v-text-field v-text-field--is-booted v-text-field--enclosed v-text-field--outlined">
                  <div class="v-input__control">
                    <div class="v-input__slot">
                      <div class="v-input__prepend-inner">
                        <div class="v-input__icon v-input__icon--prepend-inner">
                          <i aria-hidden="true" class="v-icon notranslate mdi mdi-home-map-marker theme--light"></i>
                        </div>
                      </div>
                      <fieldset aria-hidden="true">
                        <legend style="width: 0px;">
                          <span>​</span>
                        </legend>
                      </fieldset>
                      <div class="v-text-field__slot">
                        <label for="input-147" class="v-label theme--light" style="left: 0px; right: auto; position: absolute;">
                          <!-- Alamat / Lokasi -->
                        </label>
                        <gmap-autocomplete placeholder="Alamat / Lokasi Perusahaan" 
                          :value="form.address" 
                          :select-first-on-enter="true" 
                          @place_changed="setPlace">
                        </gmap-autocomplete>
                      </div>
                    </div>
                    <div class="v-text-field__details">
                      <div class="v-messages theme--light">
                        <div class="v-messages__wrapper">
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <v-row>
                  <v-col cols="12" md="5">
                    <p class="caption mb-2">
                      <b>Provinsi</b>
                    </p>
                    <v-select
                      dense
                      outlined
                      single-line
                      :color="style.primary"
                      placeholder="ex: DI Yogyakarta"
                      :items="config.province"
                      item-value="province_id"
                      item-text="province_name"
                      item-color="color-first"
                      v-model="form.province_id"
                      v-on:change="form.city_id = ''; form.city_name = '';">
                      <template v-slot:append>
                        <v-icon color="#7B7B7B">mdi-chevron-down-box</v-icon>
                      </template>
                    </v-select>
                  </v-col>
                  <v-col cols="12" md="5">
                    <p class="caption mb-2">
                      <b>Kabupaten</b>
                    </p>
                    <v-select
                      dense
                      outlined
                      single-line
                      :color="style.primary"
                      placeholder="ex: Kab. Sleman"
                      :items="config.city"
                      item-value="city_id"
                      item-text="city_name"
                      item-color="color-first"
                      :disabled="form.province_id === ''"
                      v-model="form.city_id">
                      <template v-slot:append>
                        <v-icon color="#7B7B7B">mdi-chevron-down-box</v-icon>
                      </template>
                    </v-select>
                  </v-col>
                </v-row>
              </div>    
                        
              <quill-editor 
                class="mb-12"
                ref="myTextEditor"
                :options="option"
                v-model="form.detail">
              </quill-editor>
            </v-form>
          </ValidationObserver>
        </v-card-text>
        <v-card-text class="pt-0 pb-0">
          <v-alert type="error" text dense prominent 
            v-show="error.message.length > 0"
            v-html="error.message">
          </v-alert>
        </v-card-text>
        <v-card-actions class="pb-5 px-6">
          <v-spacer/>
          <v-btn
            outlined
            small
            :color="style.primary"
            class="text-capitalize green--text mx-1"
            :loading="process.form"
            :disabled="process.form"
            @click="save">
            <v-icon small class="mr-1">mdi-check</v-icon>
            Simpan
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog.tutorial" 
      persistent
      scrollable
      width="700">
      <v-card class="border-radius box-shadow">
        <v-card-title class="body-2 text-first d-flex blue-grey lighten-5 py-5">
          Kelengkapan Data Perusahaan
        </v-card-title>
        <v-card-text style="height: 100vh;" class="mt-5">
          <p class="body-2">
            Silahkan melengkapi data perusahaan anda diantaranya :
          </p>
          <ul class="tutorial body-2 line-text-second">
            <li>
              <p class="font-weight-bold mb-1">
                Pengguna
              </p>
              <p class="mb-1">
                Menambahkan data pengguna antara lain Supervisor, Administrator, Developer, Finance dan Marketing dengan mengklik menu
              </p>
              <p>
                <b>Pengaturan</b> > <b>Tab Pengguna</b> > 
                <v-btn
                  :color="style.primary"
                  elevation="3"
                  small
                  class="text-capitalize white--text"
                  href="/setting/member" target="_blank">
                  <v-icon small class="mr-1">mdi-plus</v-icon>
                  Pengguna
                </v-btn>
              </p>
              <v-img
                class="mb-6"
                :src="require('@/assets/tutorial/pengguna.png')">
              </v-img>
            </li>
            <li>
              <p class="font-weight-bold mb-1">
                Fasilitas
              </p>
              <p class="mb-1">
                Menambahkan data fasilitas antara lain Semua, Umum dan Pribadi dengan mengklik menu
              </p>
              <p>
                <b>Pengaturan</b> > <b>Tab Fasilitas</b> >
                <v-btn
                  :color="style.primary"
                  elevation="3"
                  small
                  class="text-capitalize white--text"
                  href="/setting/facility" target="_blank">
                  <v-icon small class="mr-1">mdi-plus</v-icon>
                  Fasilitas
                </v-btn>
              </p>
              <v-img
                class="mb-6"
                :src="require('@/assets/tutorial/fasilitas.png')">
              </v-img>
            </li>
            <li>
              <p class="font-weight-bold mb-1">
                Bank
              </p>
              <p class="mb-1">
                Menambahkan data bank antara lain Bank Company dan Bank KPR dengan mengklik menu
              </p>
              <p>
                <b>Pengaturan</b> > <b>Tab Bank</b> >
                <v-btn
                  :color="style.primary"
                  elevation="3"
                  small
                  class="text-capitalize white--text"
                  href="/setting/bank" target="_blank">
                  <v-icon small class="mr-1">mdi-plus</v-icon>
                  Bank
                </v-btn>
              </p>
              <v-img
                class="mb-6"
                :src="require('@/assets/tutorial/bank.png')">
              </v-img>
            </li>
            <li>
              <p class="font-weight-bold mb-1">
                Dokumen
              </p>
              <p class="mb-1">
                Menambahkan data dokumen dengan mengklik menu
              </p>
              <p>
                <b>Pengaturan</b> > <b>Tab Dokumen</b> >
                <v-btn
                  :color="style.primary"
                  elevation="3"
                  small
                  class="text-capitalize white--text"
                  href="/setting/document" target="_blank">
                  <v-icon small class="mr-1">mdi-plus</v-icon>
                  Dokumen
                </v-btn>
              </p>
              <v-img
                class="mb-6"
                :src="require('@/assets/tutorial/dokumen.png')">
              </v-img>
            </li>
            <li>
              <p class="font-weight-bold mb-1">
                Config DP
              </p>
              <p class="mb-1">
                Menambahkan data config DP dengan mengklik menu
              </p>
              <p>
                <b>Pengaturan</b> > <b>Tab Config DP</b> >
                <v-btn
                  :color="style.primary"
                  elevation="3"
                  small
                  class="text-capitalize white--text"
                  href="/setting/dp" target="_blank">
                  <v-icon small class="mr-1">mdi-pencil-minus-outline</v-icon>
                  Config DP
                </v-btn>
              </p>
              <v-img
                class="mb-6"
                :src="require('@/assets/tutorial/dp.png')">
              </v-img>
            </li>
            <li>
              <p class="font-weight-bold mb-1">
                Config SPKPR
              </p>
              <p class="mb-1">
                Menambahkan data config SPKPR dengan mengklik menu
              </p>
              <p>
                <b>Pengaturan</b> > <b>Tab Config SPKPR</b> >
                <v-btn
                  :color="style.primary"
                  elevation="3"
                  small
                  class="text-capitalize white--text"
                  href="/setting/spkpr" target="_blank">
                  <v-icon small class="mr-1">mdi-pencil-minus-outline</v-icon>
                  Config SPKPR
                </v-btn>
              </p>
              <v-img
                class="mb-6"
                :src="require('@/assets/tutorial/spkpr.png')">
              </v-img>
            </li>
            <li>
              <p class="font-weight-bold mb-1">
                Config TTD
              </p>
              <p class="mb-1">
                Menambahkan data config TTD dengan mengklik menu
              </p>
              <p>
                <b>Pengaturan</b> > <b>Config TTD</b> > <b>Pilih User</b>
              </p>
              <v-img
                class="mb-6"
                :src="require('@/assets/tutorial/ttd.png')">
              </v-img>
            </li>
          </ul>
        </v-card-text>
        
        <v-card-actions class="pb-5 px-6">
          <v-spacer/>
          <v-btn
            outlined
            small
            :color="style.primary"
            class="text-capitalize mx-1"
            @click="dialog.tutorial = false">
            <v-icon small class="mr-1">mdi-check</v-icon>
            Ya, Saya mengerti
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-navigation-drawer
      dark
      color="#fff"
      width="110"
      v-model="drawer"
      fixed
      app>
      <v-list>
        <v-list-item to="/profile/owner">
          <v-card
            width="75"
            height="75"
            color="#fff"
            class="box-shadow hover-menu border-radius cursor-pointer ma-auto"
            :class="'profile' === $route.path.split('/')[1] ? 'actived' : ''">
            <v-img 
              class="mx-auto my-1" 
              width="40"
              height="40"
              :src="user.image_url">
            </v-img>
            <v-card-text class="text-center pa-0 text-second one-line" style="font-size: 10px;">
              {{ user.name }}
            </v-card-text>
          </v-card>
        </v-list-item>
      </v-list>
      <v-list
        v-for="(item, index) in menu"
        :key="index"
        v-if="item.is_access == true || item.role == '*'"
      >
        <v-list-item :to="item.link">
          <v-card
            width="75"
            height="75"
            color="#fff"
            class="box-shadow hover-menu border-radius cursor-pointer ma-auto"
            :class="item.link.split('/')[1] === $route.path.split('/')[1] ? 'actived' : ''">
            <v-card-title class="justify-center pb-1">
              <v-icon color="#7B7B7B">{{ item.icon }}</v-icon>
            </v-card-title>
            <v-card-text class="text-center pa-0 text-second" style="font-size: 10px;">
              {{ item.label }}
            </v-card-text>
          </v-card>
        </v-list-item>
      </v-list>
      <v-list>
        <v-list-item>
          <v-card
            width="75"
            height="75"
            color="#fff"
            class="box-shadow hover-menu border-radius cursor-pointer ma-auto"
            @click="logout">
            <v-card-title class="justify-center pb-1">
              <v-icon color="#7B7B7B">mdi-logout</v-icon>
            </v-card-title>
            <v-card-text class="text-center pa-0  text-second" style="font-size: 10px;">
              Keluar
            </v-card-text>
          </v-card>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar
      :clipped-left="clipped"
      color="#fff"
      fixed
      nav
      elevation="0"
      app>
      <v-app-bar-nav-icon class="hidden-md-and-up"
        @click.stop="drawer = !drawer"/>
      <v-toolbar-title class="body-2 pl-3 text-second d-flex align-center">
        <router-link to="/">
          <v-img
            width="115"
            height="auto"
            :src="require('@/assets/logo/logo.png')">
          </v-img>
        </router-link>
        <span class="mx-1">
          <v-icon x-small>mdi-chevron-double-right</v-icon>
        </span>
        <span class="font-weight-bold">
          {{ $route.meta.title }}
        </span>
      </v-toolbar-title>
      <v-spacer/>
      <v-btn 
        text
        class="body-2 text-capitalize"
        color="#8BC541"
        @click="dialog.tutorial = true">
        <v-icon :small="$vuetify.breakpoint.name !== 'xs' ? true : false" :class="$vuetify.breakpoint.name !== 'xs' ? 'mr-1' : ''">mdi-help-circle-outline</v-icon>
        <span v-if="$vuetify.breakpoint.name !== 'xs'">
          Bantuan
        </span>
      </v-btn>
    </v-app-bar>
  </div>
</template>

<script>
  import { TokenService } from "../service/Storage.Service";
  import { get, post, put, destroy } from "@/service/Axios";
  import ImageInput from "@/components/ImageInput.vue";
  export default {
    data () {
      return {
        option: {
          modules: {
            toolbar: [
              ['bold', 'italic', 'underline'],
              [{ 'list': 'ordered'}, { 'list': 'bullet' }],
              [{ 'size': ['small', false, 'large', 'huge'] }],
              [{ 'color': [] }, { 'background': [] }],
              [{ 'align': [] }]
            ]
          },
          placeholder: 'Keterangan Perusahaan'
        },
        dialog: {
          tutorial: false,
          company: false
        },
        clipped: false,
        drawer: true,
        menu: [
          /*
          administrator
          developer
          finance
          marketing
          partner
          superuser
          supervisor
          teknik
          */
          {
            label: 'Beranda',
            icon: 'mdi-home',
            link: '/dashboard',
            role: ['*']
          },
          {
            label: 'Proyek',
            icon: 'mdi-folder-home-outline',
            link: '/project',
            role: ['superuser', 'administrator', 'developer', 'teknik']
          },
          {
            label: 'Persetujuan',
            icon: 'mdi-check-network-outline',
            link: '/approval/discount',
            role: ['superuser', 'supervisor', 'finance']
          },
          {
            label: 'Tagihan',
            icon: 'mdi-basket-outline',
            link: '/invoice',
            role: ['superuser', 'administrator']
          },
          {
            label: 'Laporan',
            icon: 'mdi-file-table-outline',
            link: '/report',
            role: ['superuser', 'supervisor', 'administrator', 'finance']
          },
          // {
          //   label: 'Notifikasi',
          //   icon: 'mdi-bell-outline',
          //   link: '/'
          // },
          {
            label: 'Pengaturan',
            icon: 'mdi-cog-outline',
            link: '/setting/member',
            role: ['superuser', 'supervisor', 'administrator']
          }
        ],
        edit: {
          address: true
        },
        images: {
          url: ''
        },
        config: {
          province: [],
          city: []
        },
        center: {
          lat: 0,
          lng: 0
        },
        form: {
          name: '',
          contact_name: '',
          contact_email: '',
          contact_mobilephone: '',
          contact_phone: '',
          logo_url: '',
          address: '',
          province_id: '',
          province_name: '',
          city_id: '',
          city_name: '',
          detail: ''
        },
        process: {
          form: false
        },
        error: {
          message: ''
        },
        style: {
          primary: "#8BC541"
        }
      }
    },
    components: {
      ImageInput
    },
    computed: {
      user () {
        return this.$store.state.user
      },
      token () {
        return this.$store.state.token
      }
    },
    watch: { 
      '$route' (to, from) {

      },
      images: {
        handler: function () {
          if (this.images) {
            this.form.logo_url = this.images.url
          }
        },
        deep: true
      },
      'form.province_id': function() {
        let t = this
        let p = this.config.province.filter(function(v) {
          return t.form.province_id == v.province_id
        })

        if (p.length > 0) {
          this.form.province_name = p[0].province_name
        }

        this.setting().city()
      },
      'form.city_id': function() {
        let t = this
        let c = this.config.city.filter(function(v) {
          return t.form.city_id == v.city_id
        })

        if (c.length > 0) {
          this.form.city_name = c[0].city_name
        }
      }
    },
    mounted () {
      const debounce = (fn) => {
        let frame;
        return (...params) => {
          if (frame) { 
            cancelAnimationFrame(frame)
          }
          frame = requestAnimationFrame(() => {
            fn(...params)
          })
        } 
      };
      const storeScroll = () => {
        document.documentElement.dataset.scroll = window.scrollY
      }
      document.addEventListener('scroll', debounce(storeScroll), { passive: true })
      storeScroll()

      if (this.user.company_name === '') {
        this.dialog.company = true

        this.form.contact_name = this.user.name
        this.form.contact_email = this.user.email
        this.form.contact_mobilephone = this.user.mobilephone

        this.setting().province()
        this.getGeoLocation()
      }

      var menu_temp = []

      this.menu.forEach(item => {
        item.is_access = false;

        this.user.user_company_roles_name.forEach(obj => {
          //console.log(obj)
          //console.log(item.role)
          //console.log(item.role.includes(obj))

          if (item.role.includes(obj)) {
            item.is_access = true;
          }          
        })

        menu_temp.push(item)
      })

      this.menu = menu_temp

      //console.log(this.menu)
    },
    methods: {
      setting() {
        let t = this
        return {
          async province() {
            get(`location/get-province`)
            .then(response => {
              let res = response.data;
              if (res.status == 200) {
                t.config.province = res.data.province
              }
            })
          },
          async city() {
            get(`location/get-city`, {
              params: { province_id: t.form.province_id }
            })
            .then(response => {
              let res = response.data;
              if (res.status == 200) {
                t.config.city = res.data.city
              }
            })
          }
        }
      },
      getGeoLocation() {
        navigator.geolocation.getCurrentPosition(position => {
          this.center = {
            lat: position.coords.latitude,
            lng: position.coords.longitude
          }
        })
      },
      setPlace(place) {
        this.center = {
          lat: place.geometry.location.lat(),
          lng: place.geometry.location.lng()
        }

        this.form.address = place.formatted_address
      },
      async save() {
        this.error.message = ''
        const isValid = await this.$refs.observer.validate()
        if (isValid) {
          this.process.form = true
          await post(`auth/company/company/update`, {
            data: {
              name: this.form.name,
              contact_name: this.form.contact_name,
              contact_email: this.form.contact_email,
              contact_mobilephone: this.form.contact_mobilephone,
              contact_phone: this.form.contact_phone,
              logo_url: this.form.logo_url,
              address: this.form.address,
              province_id: this.form.province_id,
              province_name: this.form.province_name,
              city_id: this.form.city_id,
              city_name: this.form.city_name,
              detail: this.form.detail
            }
          }).then(response => {
            let res = response.data
            if (res.status === 200) {
              this.edit.general = false

              let data = {
                company_id: this.user.company_id,
                company_roles_id: this.user.company_roles_id,
                company_type: this.user.company_type,
                company_name: this.form.name,
                email: this.user.email,
                id: this.user.id,
                image_url: this.user.image_url,
                is_verified: this.user.is_verified,
                mobilephone: this.user.mobilephone,
                name: this.user.name,
                role: this.user.role,
                type: this.user.company_id === '0' ? 'customer' : 'company'
              }

              TokenService.saveToken(
                this.token,
                JSON.stringify(data)
              )

              this.$store.state.user = data

              this.dialog.company = false
              this.dialog.tutorial = true

              this.process.form = false
            } else {
              this.process.form = false
              this.error.message = res.msg
            }
          })
        }
      },
      logout() {
        TokenService.removeToken()
        window.location = '/'
      }
    },
    created () {
      if (process.browser) {
        if ('Notification' in window && 'serviceWorker' in navigator) {
          
        }
      }
    }
  }
</script>

<style scoped>
.hover-menu:hover, .actived {
  background: #ddffb1 !important;
}
ul.tutorial {
  list-style-type: decimal;
}
</style>